import {
  Component,
  OnInit,
  Input,
  ViewEncapsulation,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  ViewChild,
  OnDestroy,
} from '@angular/core';
import { PlActions, PlColumnActions } from '../../actions';
import { Store, select } from '@ngrx/store';
import { AppState } from 'app/reducers';
import { Observable, Subject } from 'rxjs';
import { AnaGroupRow } from 'app/main/analytics/analytics-groups/analytics-groups.component';
import {
  ColDef,
  ClientSideRowModelModule,
  GridOptions,
} from '@ag-grid-community/all-modules';
import { AnalyticsEntry } from 'app/api/analytics.api.service';
import { PlSelectors, PlColumnSelectors } from '../../selectors';
import { AgGridAngular } from '@ag-grid-community/angular';
import * as _ from 'lodash';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-pl-options',
  templateUrl: './pl-options.component.html',
  styleUrls: ['./pl-options.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PlOptionsComponent implements OnInit, OnChanges, OnDestroy {
  fieldOption = 'rows';
  fieldType: string;
  fieldOperator = 'sum';
  fieldCalculatedName: string;
  fieldColumnName: string;

  selectedGroup: AnalyticsEntry;
  colorFieldCalculated = 'fuse-white-500';
  isInvalid$: Subject<boolean> = new Subject();
  unsubscribeAll: Subject<any>;

  public modules = [ClientSideRowModelModule];
  public groupsColumnDefs: ColDef[] = [
    {
      headerName: 'Nom',
      field: 'name',
      dndSource: true,
      cellClass: ({ data }) => data && data.color,
      // rowDrag: true,
    },
  ];
  public sumColumnDefs: ColDef[] = [
    {
      headerName: 'Elements à additionner',
      width: 252,
      field: 'name',
      cellClass: ({ data }) => data && data.color,
      // rowDrag: true,
    },
  ];

  public numeratorColumnDefs: ColDef[] = [
    {
      headerName: 'Numérateur',
      width: 252,
      field: 'name',
      cellClass: ({ data }) => data && data.color,
      // rowDrag: true,
    },
  ];
  public denominatorColumnDefs: ColDef[] = [
    {
      headerName: 'Dénominateur',
      width: 252,
      field: 'name',
      cellClass: ({ data }) => data && data.color,
      // rowDrag: true,
    },
  ];
  public availableColumnDefs: ColDef[] = [
    {
      headerName: 'Colonnes disponibles',
      width: 252,
      dndSource: true,
      field: 'name',
      // rowDrag: true,
    },
  ];
  public customColumnDefs: ColDef[] = [
    {
      headerName: 'Colonne à additionner',
      width: 252,
      field: 'name',
      // rowDrag: true,
    },
  ];

  gridOptions: GridOptions = {
    rowDragManaged: true,
    animateRows: true,
  };

  public customColumnData = [];
  public availableColumnData = [];
  public denominatorData = [];
  public numeratorData = [];
  public plCalculatedGridApi;

  // tslint:disable-next-line: no-output-on-prefix
  @Output() onFieldTypeChange = new EventEmitter();
  // tslint:disable-next-line: no-output-on-prefix
  @Output() onFieldOperatorChange = new EventEmitter();
  @Input() rowGroup: Observable<AnaGroupRow[]>;
  @Input() rowAna2: Observable<AnaGroupRow[]>;
  @Input() rowCalculated: AnaGroupRow[];

  @ViewChild('plNumeratorGrid', { static: false })
  plNumeratorGrid: AgGridAngular;
  @ViewChild('plDenominatorGrid', { static: false })
  plDenominatorGrid: AgGridAngular;
  @ViewChild('plCalculatedGrid', { static: false })
  plCalculatedGrid: AgGridAngular;
  @ViewChild('plAvailableColumnGrid', { static: false })
  plAvailableColumnGrid: AgGridAngular;
  @ViewChild('plCustomColumnGrid', { static: false })
  plCustomColumnGrid: AgGridAngular;

  constructor(private store: Store<AppState>) {
    this.unsubscribeAll = new Subject();
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }

  ngOnInit(): void {
    this.isInvalid$.next(true);

    this.store.pipe(
      takeUntil(this.unsubscribeAll),
      select(PlColumnSelectors.selectPlColumns)
    ).subscribe((columnDefs) => {
        this.availableColumnData = [];
        columnDefs.forEach((col) => {
          if (col.name) {
            if (col.children) {
              col.children.forEach((c) => {
                this.availableColumnData.push({
                  name: c.headerName,
                });
              });
            } else {
              this.availableColumnData.push({
                name: col.name,
              });
            }
          }
        });

        if (this.plAvailableColumnGrid) {
          this.plAvailableColumnGrid.api.setRowData(this.availableColumnData);
        }
      });
  }

  ngOnChanges(simpleChange: SimpleChanges): void {
    if (simpleChange.rowCalculated && simpleChange.rowCalculated.currentValue) {
      this.isInvalid$.next(false);
    }
  }

  onColorChanged(event): void {
    this.colorFieldCalculated = event.class;
  }

  fieldTypeChange(fieldType): void {
    this.onFieldTypeChange.emit(fieldType);
    if (fieldType === 'calculated') {
      this.rowCalculated = [];
    }
    this.showAddButton();
  }

  fieldOperatorChange(fieldOperator): void {
    this.onFieldOperatorChange.emit(fieldOperator);
    this.isInvalid$.next(true);
  }

  showAddButton(): boolean {
    if (this.fieldType) {
      if (this.fieldType === 'ana2' || this.fieldType === 'groups') {
        return false;
      }
    }
    return true;
  }

  initOption(): void {
    this.fieldOperator = null;
    this.fieldCalculatedName = null;
    this.fieldColumnName = null;
    this.rowCalculated = [];
    this.fieldType = null;
    this.numeratorData = [];
    this.denominatorData = [];
    this.customColumnData = [];
  }

  gridDragOver(event): void {
    const dragSupported = event.dataTransfer.types.length;
    if (dragSupported) {
      event.dataTransfer.dropEffect = 'move';
    }
    event.preventDefault();
  }

  gridDrop(event, to): void {
    event.preventDefault();
    const userAgent = window.navigator.userAgent;
    const isIE = userAgent.indexOf('Trident/') >= 0;
    const jsonData = event.dataTransfer.getData(
      isIE ? 'text' : 'application/json'
    );
    const data = JSON.parse(jsonData);

    if (to === 'sum') {
      const isAlreadyIn = _.findIndex(
        this.rowCalculated,
        (r) => r.key === data.key
      );
      if (isAlreadyIn < 0) {
        this.rowCalculated.push(data);
        this.plCalculatedGrid.api.setRowData(this.rowCalculated);
        this.isInvalid$.next(false);
      }
    } else if (to === 'numerator') {
      data.categoryCalculated = 'numerator';
      this.numeratorData = [...data];
      this.plNumeratorGrid.api.setRowData(this.numeratorData);
    } else if (to === 'denominator') {
      data.categoryCalculated = 'denominator';
      this.denominatorData = [...data];
      this.plDenominatorGrid.api.setRowData(this.denominatorData);
    }

    if (this.numeratorData.length > 0 && this.denominatorData.length > 0) {
      this.isInvalid$.next(false);
    }

    if (to === 'column') {
      this.customColumnData = [...this.customColumnData, data];
      this.plCustomColumnGrid.api.setRowData(this.customColumnData);
    }
  }

  addRow(): void {
    if (this.fieldType === 'calculated') {
      if (this.fieldOperator === 'percentage') {
        this.rowCalculated = [...this.numeratorData, ...this.denominatorData];
      }

      this.store.dispatch(
        PlActions.plAddRowRequested({
          entry: {
            name: this.fieldCalculatedName,
            key: String(new Date().valueOf()),
            fieldType: this.fieldType,
            fieldOperator: this.fieldOperator,
            color: this.colorFieldCalculated,
            rows: this.rowCalculated,
          },
        })
      );
      this.initOption();
    } else {
      if (this.selectedGroup) {
        this.store.dispatch(
          PlActions.plAddRowRequested({
            entry: {
              ...this.selectedGroup,
              fieldType: this.fieldType,
            },
          })
        );
      } else {
        this.isInvalid$.next(true);
      }
    }
  }

  addColumn(): void {
    this.store.dispatch(
      PlColumnActions.plAddColumnRequested({
        entry: {
          name: this.fieldColumnName,
          key: String(new Date().valueOf()),
          columns: this.customColumnData
        },
      })
    );
    this.initOption();
  }

  onGroupsSelectionChanged(params): void {
    const selectedRow = params.api.getSelectedRows();
    if (selectedRow.length === 1) {
      this.selectedGroup = selectedRow[0];
      this.isInvalid$.next(false);
    } else {
      this.isInvalid$.next(true);
    }
  }

  onGroupsGridReady(params): void {}

  onPlCalculatedGridReady(params): void {
    this.plCalculatedGridApi = params.gridApi;
  }
}
